import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import CriticReviewItem from './CriticReviewItem';
import MoreButton from '../../../../components/button/MoreButton';
import CreateButton from '../../../../components/button/CreateButton';
import { useCriticReviews, useDeleteCriticReview } from '../../hooks/useCriticReviews';
import theme from '../../../../theme';
import { useUserStore } from '../../../../stores/userStore';

const INITIAL_DISPLAY_COUNT = 3;

const CriticReviewSection = ({ albumId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useUserStore();
  const { data: reviews = [] } = useCriticReviews(albumId);
  const deleteCriticReview = useDeleteCriticReview(albumId);
  const [expanded, setExpanded] = useState(false);

  const totalCount = reviews.length;

  const handleEdit = (review) => {
    navigate(`${location.pathname}/critic-reviews/${review.id}/edit${location.search}`, { state: { albumId } });
  };

  const handleDelete = async (reviewId) => {
    try {
      await deleteCriticReview.mutateAsync(reviewId);
    } catch (err) {
      console.error('Failed to delete critic review:', err);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {/* 헤더 */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'space-between', md: 'flex-start' },
          pb: 1,
          borderBottom: `1px solid ${theme.palette.grey.line}`,
        }}
      >
        <Typography
          fontSize={{ xs: 16, md: 18 }}
          fontWeight={'bold'}
          color={theme.palette.black[9]}
        >
          평론가 리뷰 ({totalCount})
        </Typography>
        {isAdmin && (
          <CreateButton
            text="등록"
            onClick={() =>
              navigate(`${location.pathname}/critic-reviews/create${location.search}`, { state: { albumId } })
            }
            sx={{
              ml: 4,
              width: 78,
              height: 32,
              minHeight: 32,
              padding: 0,
              fontSize: 14,
            }}
          />
        )}
      </Box>

      {/* 리뷰 리스트 + 더보기 버튼 */}
      {totalCount > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: { xs: 0, md: 2.25 },
          }}
        >
          <Box sx={{ width: '100%' }}>
            {(expanded ? reviews : reviews.slice(0, INITIAL_DISPLAY_COUNT)).map((review) => (
              <CriticReviewItem
                key={review.id}
                review={review}
                isAdmin={isAdmin}
                onEdit={handleEdit}
                onDelete={(id) => handleDelete(id)}
              />
            ))}
          </Box>

          {totalCount > INITIAL_DISPLAY_COUNT && (
            <MoreButton onClick={() => setExpanded(!expanded)}>
              {expanded ? '접기' : '더보기'}
            </MoreButton>
          )}
        </Box>
      )}
    </Box>
  );
};

export default CriticReviewSection;
